import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterPVenta'
})
export class FilterPVentaPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!args) return value;
    return value.filter( el => {
      let rVal = (el.desLargo01.toLocaleLowerCase().includes(args.toLowerCase())) || (el.desLargo02.toLocaleLowerCase().includes(args.toLowerCase())) || (el.desLargo03.toLocaleLowerCase().includes(args.toLowerCase()))
                  || (el.desLargo04.toLocaleLowerCase().includes(args.toLowerCase())) || (el.desLargo05.toLocaleLowerCase().includes(args.toLowerCase()));
      return rVal;
    })
  }

}
